import { useState, useEffect } from 'react';
import useGlobalAppService from '../../appService/hooks/useGlobalAppService';

const useGlobalUserData = (getLogonProfile) => {
  const [globalData, setGlobalData] = useState(null);
  const [globalAppServiceReady, globalAppService] = useGlobalAppService();

  useEffect(() => {
    const asyncSubAndGetData = async () => {
      if (globalAppServiceReady) {
        let logonProfileData = await globalAppService.services.logonProfile.fetch();
        setGlobalData(logonProfileData);

        const { refresh } = globalAppService.services.logonProfile.events;

        globalAppService.services.logonProfile.on(refresh, async () => {
          logonProfileData = await globalAppService.services.logonProfile.fetch();
          setGlobalData(logonProfileData);
        });
        return globalAppService.services.logonProfile.off(refresh);
      }
      return null;
    };

    asyncSubAndGetData();
  }, [globalAppServiceReady, getLogonProfile]);

  return [globalAppServiceReady, globalData];
};

export default useGlobalUserData;
